import { render, staticRenderFns } from "./LayoutHome.vue?vue&type=template&id=4bf51cd9&scoped=true&"
import script from "./LayoutHome.vue?vue&type=script&lang=js&"
export * from "./LayoutHome.vue?vue&type=script&lang=js&"
import style0 from "./LayoutHome.vue?vue&type=style&index=0&id=4bf51cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf51cd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf51cd9')) {
      api.createRecord('4bf51cd9', component.options)
    } else {
      api.reload('4bf51cd9', component.options)
    }
    module.hot.accept("./LayoutHome.vue?vue&type=template&id=4bf51cd9&scoped=true&", function () {
      api.rerender('4bf51cd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutHome.vue"
export default component.exports